import { SettingsPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";
import { Navigate } from "react-router-dom";

export const internationalSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("International", {
          context: "merchant settings breadcrumb for international commerce",
        });
      },
    },
    path: "international",
    children: [
      { index: true, element: <Navigate replace to="returns" /> },
      {
        handle: {
          get breadcrumb() {
            return t("International Returns", {
              context: "merchant settings label for international returns",
            });
          },
          permission: settingsPagePermission("international/returns"),
        },
        path: "returns",
        lazy: async () => {
          const { InternationalPage } =
            await import("../../../../setting/international/international-page");
          return { Component: InternationalPage };
        },
      },
      {
        handle: {
          get breadcrumb() {
            return t("Customs catalog", {
              context: "merchant settings label for the customs catalog",
            });
          },
          permission: [
            SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
            SettingsPermissions.SET_SHIPPING_SETTINGS,
          ],
        },
        path: "catalog",
        lazy: async () => {
          const { CustomsCatalogPage } =
            await import("../../../../setting/international/catalog/customs-catalog-page");
          return { Component: CustomsCatalogPage };
        },
      },
    ],
  },
];
